// import mockRecSessions from '../pages/ProjectMyStudio/mockRecSessions';

const initialStore = {
    // ui related
    isError404: false,

    // React Query integration - server state cached in Zustand
    projects: [],
    projectsLoading: false,
    projectsError: null,

    team: [],
    teamLoading: false,
    teamError: null,

    cueSheet: [],
    cueSheetLoading: false,
    cueSheetError: null,

    userData: {},
    userLoading: false,
    userError: null,

    currentProject: null, // used when getting specific project via API; DO NOT use for displaying data on the page!
    currentProjectLoading: false,
    currentProjectError: null,

    // rec sessions
    recSessions: [],
    recSessionsLoading: false,
    recSessionsError: null,
    selectedRecItemId: null,

    // my studio
    projectVideos: [],
    /*projectClips: [],*/
    selectedVideo: 0,
    cueSheetPanel: 'music', // 'music', 'sfx', 'mix', 'calendar'
    myStudioLeftPanel: '', // 'video', 'music', 'audio', 'rec'
    myStudioMusicPanel: 'references', // 'references', 'soundtrack'
    myStudioAudioPanel: 'sfx', // 'sfx', 'mix'
    timelineEditorUiCollapsed: false, // true
    timelineEditingMode: '', // 'cut'
    timelineState: 'stopped', // 'stopped', 'playing', 'backward', 'forward'
    timelineRefMode: false, // false = MUSIC active, true = REFERENCE active
    timelineVolume: 75,
    trackMusicVolume: 100,
    trackMusicMuted: false,
    trackSfxVolume: 100,
    trackSfxMuted: false,
    trackDialogueVolume: 100,
    trackDialogueMuted: false,

    // video caching
    cachedVideoUrl: null,
    videoCacheLoading: false,
    videoCacheError: null,

    // timeline persistence
    /*projectTimeline: null,
    timelineLoading: false,
    timelineError: null,*/

    // audio caching
    cachedAudioUrls: {},
    audioCacheLoading: false,
    audioCacheError: null,
    cachedRecAudioUrls: {},

    stemSplitterSelection: null, // { layer, startPos, endPos, timelineType: 'studio'|'rec' }
    generateInstrumentSelection: null, // { layer, startPos, endPos, timelineType: 'rec' }

    aiNoteSelection: null, // { layer, startPos, endPos, timelineType: 'studio'|'rec', mode: 'penai'|'pinai'|'moodai' }
    aiNoteSubmissions: [], // [{ id, mode, note, layer, startPos, endPos, timelineType, createdAt }]
    penCanvasData: null,         // { json: {}, svg: '<svg>...' } — current drawing snapshot
    penCanvasResetSignal: 0,     // bump to clear PenCanvas
    activeAiNoteHighlight: null, // submission ID to show selection overlay on timeline
    penaiViewData: null, // { id, canvasJson } — penai message currently being viewed in timeline

    messages: null,
    messagesLoading: false,
    messagesError: null,

    plans: [],
    plansLoading: false,
    plansError: null,

    // user
    token: '',
    companies: [],
    chosenCompanyId: 0,
    users: [],
    userCounters: null,
    userCountersLoading: false,
    userCountersError: null,
}

export default initialStore;